<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title" v-show="barcodeType == 'members'">{{ $t('Modal.Members.msg1') }}</div>
        <div class="lyr-title" v-show="barcodeType == 'coupon'">{{ $t('Modal.Members.msg5') }}</div>
        <div class="ft-point">
          {{ $t('Modal.Members.msg2') }}
        </div>
        <div class="lyr-txt">{{ $t('Modal.Members.msg3') }}</div>
      </div>
      <div class="layer__body">
        <img :src="imgSrc" alt="" class="img-size" @mouseup="nextProc()" />
      </div>
      <div class="layer__button">
        <button class="btn btn--line btn--xlg btn-anim" @mouseup="$emit('membersClose')">{{ $t('Modal.Members.msg4') }}</button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'members',
  data() {
  },
  mounted() {
  },
  props: {
    barcodeType: String,
  },
  methods: {
    nextProc() {
      let type = this.barcodeType;
      if (type == 'coupon') {
        this.$emit('setCoupon');
      } else if (type == 'members') {
        this.$emit('setMembers');
      }
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    imgSrc() {
      let type = this.barcodeType.toUpperCase();
      if (type == 'MEMBERS') return require('@/assets/images/user/artwork_popup_members_3d.gif');
      else if (type == 'COUPON') return require('@/assets/images/user/artwork_popup_members_3d.gif');
      else return require('@/assets/images/user/artwork_popup_members_3d.gif');
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
